// public class LabRecordModel
// { 
//     public int labtest_id { get; set; }
//     public int pet_no { get; set; }
//     public string labtest_val { get; set; }
//     public int seq_no { get; set; }
//     public DateTime labtest_date { get; set; }
//     public string recordedby { get; set; }  
// }
// units, range, comment
export class LabRecordModel {
    public labtest_id;
    public pet_no;
    public labtest_val; 
    public test_code;
    public test_desc;
    public labtest_date;
    public recordedby; 
    public units; 
    public range;
    public comment;

    constructor(
        labtest_id?: number,
        pet_no?: number,
        labtest_val?: string, 
        test_code?: string,
        test_desc?: string,
        labtest_date?: Date,
        recordedby?: string,
        units?: string,
        range?: string,
        comment?: string
    ) {
        this.labtest_id = labtest_id;
        this.pet_no = pet_no;
        this.labtest_val = labtest_val; 
        this.test_code = test_code;
        this.test_desc = test_desc;
        this.labtest_date = labtest_date;
        this.recordedby = recordedby;
        this.units = units;
        this.range = range;
        this.comment = comment;
    }
}
